import {btn, checkbox, CheckboxField, comp, Component, Notifier, fieldset, router, tbar, win} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {registrationForm} from "./components/RegistrationForm.js";
import {languageDS, LanguageEntity} from "./data/LanguagesStore.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";
import {IfwErrorParser} from "./util/IfwErrorParser.js";

export class Register extends Component {
	private Notifier: any;

	constructor() {
		super("section");
		this.itemId = "register";
		this.id = "register";
		this.cls = "ifw-card";

		const p = registrationForm({readOnly: false});

		p.form.on("submit", () => {
			const authData = p.getAuthenticationData();
			let cp = CurrentParticipant.get();
			delete cp.agreedTerms;
			delete cp["user.username"];
			delete cp["user.password"];
			delete cp["user.passwordRepeat"];
			Object.assign(cp, authData);
			for (const key of Object.keys(cp)) {
				if (key.startsWith(("customFields."))) {
					delete cp[key];
				}
			}

			const url = ServerApi.url("elearning/frontend/participants/validate", {});
			ServerApi.call(url, cp, "POST").then((result) => {
				if (result.success) {
					void router.goto("confirm-registration");
				} else {
					// Should not happen
					Notifier.warning(t("There was an unknown error. Please check your inpout"))
					return false;
				}
			}).catch((reason) => {
				const o = IfwErrorParser.parseAndReturn(reason);
				if (!o) {
					return;
				}
				for (let fld in o) {
					if (fld === "username") {
						p.usernameFld.setInvalid(t("Sorry, this username is already taken"));
					} else if (fld === "email") {
						p.emailFld.setInvalid(t("The e-mail address is invalid"));
					} else {
						IfwInvalidator.setInvalidPasswordMessage(p.passwordFld, o[fld]);
					}
				}
				return false;
			})
		});

		const pc = JSON.parse(localStorage.getItem("portalConfig")!);

		Promise.all([p.load(), CurrentParticipant.readIf()])
			.then(async ([_res1, res2]) => {
				this.items.add(p);
				const lang = await languageDS.single(res2.languageId || sessionStorage.getItem("languageId")!);
				if (lang!.generalTerms && !res2.userId) {
					if (pc.mustAcceptTerms) {
						p.form.items.add(fieldset({},
							checkbox({
								name: "agreedTerms",
								required: true,
								label: `${t("I accept the")} ${t("privacy policy")}`,
								listeners: {
									"invalid": (cb: CheckboxField) => {
										if (!cb.isValid()) {
											cb.invalidMsg = t("You must agree to continue");
										}
										return false;
									}
								},
								buttons: [
									btn({
										icon: "shield", handler: () => {
											this.showTerms(lang!);
										}
									})
								]
							}))
						);
					} else {
						const p = comp({/*cls: "ifw-center"*/cls: "pad"},
							btn({
								cls: "outlined",
								icon: "shield",
								handler: () => {
									this.showTerms(lang!)
								}, text: t("Privacy policy")
							})
						);
						this.items.add(p);
					}
				}


				this.items.add(tbar({cls: "ifw-bbar"},
					btn({text: t("Back"), route: ""}),
					"->",
					btn({
						type: "submit", text: t("Continue"), handler: () => {
							p.form.submit();
						}
					})
				));
			});
	}

	private showTerms(lang: LanguageEntity) {
		win({
			title: t("Terms and conditions"),
			modal: false,
			resizable: true,
			maximizable: false,
			draggable: true,
			width: 800,
			height: 600
		}, comp({cls: "pad fit scroll", html: lang!.generalTerms}))
			.show();
	}
}
